import { Injectable } from '@angular/core';
import * as QuillNamespace from 'quill';
import QuillImageDropAndPaste from './quill-image-drop-and-paste'

const Quill: any = QuillNamespace;
const Parchment = Quill.import('parchment');
const Delta = Quill.import('delta');

function lineBreakMatcher() {
  let newDelta = new Delta();
  newDelta.insert({'break': ''});
  return newDelta;
}

@Injectable()
export class QuillConfigService {
  color_list = [
    "#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff",
    "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff",
    "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff",
    "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2",
    "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466",
    "#ff5500",
  ]


  constructor() {
    this.registerQuillAdditionalOptions()
  }

  registerQuillAdditionalOptions() {
    const sizeStyle = Quill.import('attributors/style/size')
    sizeStyle.whitelist = ['10px', '12px', '14px', '16px', '18px', '20px', '24px', '30px', '32px', '36px']
    Quill.register(sizeStyle, true)

    let Break = Quill.import('blots/break');
    let Embed = Quill.import('blots/embed');

    Break.prototype.insertInto = function(parent, ref) {
      Embed.prototype.insertInto.call(this, parent, ref)
    };
    Break.prototype.length= function() {
        return 1;
    }
    Break.prototype.value= function() {
        return '\n';
    }

    // Quill.register('modules/imageResize', ImageResize)
    Quill.register('modules/imageDropAndPaste', QuillImageDropAndPaste)
  }

  getConfig(pasteImgHandler) {
    return {
      debug: 'error',
      placeholder: '1,000자 이내로 작성, 이미지의 경우 5MB 이하만 첨부 가능',
      modules: {
        toolbar: [
          [{ 'size': [false, '10px', '12px', '14px', '16px', '18px', '20px', '24px', '30px', '32px', '36px'] }],
          [
            "bold", "italic", "underline", "strike",
            {'color': this.color_list }, { background: this.color_list }
          ],
          [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
          [
            { align: "" },
            { align: "center" },
            { align: "right" },
            { align: "justify" }
          ],
          [{ indent: "-1" }, { indent: "+1" },],
          ["link", "image", "video"],
          ["clean"]
        ],
        clipboard: {
          matchers: [
            ['BR', lineBreakMatcher] 
          ]
        },
        keyboard: {
          bindings: {
            handleEnter: {
              key: 13,
              handler: function (range, context) {
                if (range.length > 0) {
                  this.quill.scroll.deleteAt(range.index, range.length);  // So we do not trigger text-change
                }
                let lineFormats = Object.keys(context.format).reduce(function(lineFormats, format) {
                  if (Parchment.query(format, Parchment.Scope.BLOCK) && !Array.isArray(context.format[format])) {
                    lineFormats[format] = context.format[format];
                  }
                  return lineFormats;
                }, {});
                var previousChar = this.quill.getText(range.index - 1, 1);
                // Earlier scroll.deleteAt might have messed up our selection,
                // so insertText's built in selection preservation is not reliable
                this.quill.insertText(range.index, '\n', lineFormats, Quill.sources.USER);
                if (previousChar == '' || previousChar == '\n') {
                  this.quill.setSelection(range.index + 2, Quill.sources.SILENT);
                } else {
                  this.quill.setSelection(range.index + 1, Quill.sources.SILENT);
                }
                // console.log(this.quill.selection)
                // this.quill.selection.scrollIntoView();
                Object.keys(context.format).forEach((name) => {
                  if (lineFormats[name] != null) return;
                  if (Array.isArray(context.format[name])) return;
                  if (name === 'link') return;
                  this.quill.format(name, context.format[name], Quill.sources.USER);
                });
              }
            },
            linebreak: {
              key: 13,
              shiftKey: true,
                handler: function (range, context) {
                  var nextChar = this.quill.getText(range.index + 1, 1)
                  var ee = this.quill.insertEmbed(range.index, 'break', true, 'user');
                  if (nextChar.length == 0) {
                    // second line break inserts only at the end of parent element
                    var ee = this.quill.insertEmbed(range.index, 'break', true, 'user');
                  }
                  this.quill.setSelection(range.index + 1, Quill.sources.SILENT);
                }
            }
          }
        },
        imageDropAndPaste: {
          handler: pasteImgHandler
        }
      },
    };
  }
}


// WEBPACK FOOTER //
// ./src/app/service/quill/quill.service.ts